import SlimSelect from 'slim-select';
import autocomplete from 'autocompleter';

/* eslint-disable */
export default class CheckoutForms {
  constructor() {
    this.wrapper = $('.js-checkout-wrapper');
    this.currentIndex = 0;
    this.classes = {
      isActive: 'is-active',
      isFilled: 'is-filled',
      isCurrent: 'is-current',
      isValidated: 'is-validated',
    };
    this.settings = {
      startDelivery: {
        elem: $('.js-delivery-type'),
        info: {
          value: 'Самовывоз'
        },
      },
      deliveryType: {
        pickup: 'Самовывоз',
        NP: 'Новая Почта',
        courier: 'Курьером по Киеву',
        other: 'Другое',
      },
      paymentType: {
        cashless: 'Безналом для юридических лиц',
        card: 'Банковской картой',
      },
      strings: {
        NPSelect: {
          placeholder: 'Оберіть відділення',
          searchText: 'Відділення не знайдено',
          searchPlaceholder: 'Пошук',
        },
        autocomplete: {
          emptyMsg: 'Відсутні результати',
        },
      }
    };
  }

  initDOM() {
    this.nextBtn = $('.js-checkout-personal-next');
    this.prevBtn = $('.js-checkout-prev');
    this.checkoutBlock = $('.js-checkout-block');
    this.steps = $('.js-checkout-step');
    this.loader = $('.js-loader');
    this.NPSelectRow = $('.js-np-select-row');
    this.selfAddressesRow = $('.js-self-addresses-row');
    this.selfAddressesSelectRow = $('.js-self-addresses-select');
    this.searchCitiesRow = $('.js-search-cities-row');
    this.formAddresses = $('.js-form-addresses');
    this.addressFields = $('.js-address-fields');
    this.entityFields = $('.js-entity-fields');
    this.cardInfo = $('.js-card-info');
    this.placesRow = $('.js-places-row');
  }

  init() {
    this.initDOM();
    this.selects();
    this.initDeliveryType(
      this.settings.startDelivery.elem,
      this.settings.startDelivery.info
    );
    this.NPGetAddresses();
    this.nextBtn.on('click', this.next.bind(this));
    this.prevBtn.on('click', this.prev.bind(this));
  }

  prev() {
    this.checkoutBlock.eq(this.currentIndex).hide();
    this.checkoutBlock.eq(this.currentIndex - 1).show();
    this.steps.eq(this.currentIndex).removeClass(this.classes.isCurrent);
    this.steps.eq(this.currentIndex - 1).removeClass(this.classes.isFilled);
    this.steps.eq(this.currentIndex - 1).addClass(this.classes.isCurrent);

    this.currentIndex -= 1;
  }

  next() {
    if (this.checkoutBlock.eq(this.currentIndex).find('.js-personal-info-static').length) {
      this.onNext();
    } else {
      window.validation.successCall = () => {
        this.onNext();
        window.validation.successCall = false;
      };
    }
  }

  onNext() {
    this.loading();

    // run callback after successful ajax call
    this.onFirstBuySubmit(() => {
      this.checkoutBlock.eq(this.currentIndex).hide();
      this.checkoutBlock.eq(this.currentIndex + 1).show();

      this.steps.eq(this.currentIndex).addClass(this.classes.isFilled);
      this.steps.eq(this.currentIndex).removeClass(this.classes.isCurrent);
      this.steps.eq(this.currentIndex + 1).addClass(this.classes.isCurrent);

      this.currentIndex += 1;

      this.resetLoading();
    });
  }

  loading() {
    this.loader.show();
  }

  resetLoading() {
    this.loader.hide();
  }

  selects() {
    const { paymentType } = this.settings;
    const customSelects = Array.prototype.slice.call(document.querySelectorAll('.js-custom-select-checkout'));
    if (!customSelects.length) return;

    customSelects.forEach(elem => {
      if ($(elem).hasClass('js-np-select')) {
        this.initNPSelect(elem);
      } else if ($(elem).hasClass('js-payment-method-select')) {
        this.initPaymentSelect(elem);
      } else {
        // eslint-disable-next-line no-new
        new SlimSelect({
          select: elem,
          showSearch: !!$(elem).attr('data-search'),
          onChange: (info) => {
            if ($(elem).hasClass('js-delivery-type')) {
              this.initDeliveryType(elem, info);
            }
            window.psInstances.forEach((ins) => {
              ins.update();
            });
          }
        });
      }
    });
  }

  initNPSelect(elem) {
    const { placeholder, searchText, searchPlaceholder } = this.settings.strings.NPSelect;
    this.NPCustomSelect = new SlimSelect({
      select: elem,
      placeholder,
      searchText,
      searchPlaceholder,
      showSearch: !!$(elem).attr('data-search'),
    });
  }

  initPaymentSelect(elem) {
    const { paymentType, deliveryType } = this.settings;
    const { placeholder } = this.settings.strings.NPSelect;
    this.paymentCustomSelect = new SlimSelect({
      select: elem,
      placeholder,
      showSearch: !!$(elem).attr('data-search'),
      onChange: (info) => {
        info.value === paymentType.cashless ? this.entityFields.show() : this.entityFields.hide();
        info.value === paymentType.card ? this.cardInfo.show() : this.cardInfo.hide();
        window.psInstances.forEach((ins) => {
          ins.update();
        });

        if ( $('select.js-delivery-type').val() === deliveryType.NP) {
          setTimeout(() => {
            $('.js-payment-method-select').find('.ss-option').eq(0).hide();
          }, 10)
        }
      }
    });
  }

  initDeliveryType(elem, info) {
    const { deliveryType } = this.settings;
    info.value === deliveryType.courier ? this.addressFields.show() : this.addressFields.hide();
    info.value === deliveryType.other ? this.placesRow.hide() : this.placesRow.show();

    if (info.value === deliveryType.NP) {
      this.NPSelectRow.show();
      $('.js-payment-method-select').find('.ss-option').eq(0).hide();
      this.paymentCustomSelect.set('Безготівково для юридичних осіб');
    } else {
      this.NPSelectRow.hide();
      $('.js-payment-method-select').find('.ss-option').eq(0).show();
    }

    if (info.value === deliveryType.pickup) {
      this.selfAddressesRow.show();
      this.selfAddressesSelectRow.show();
      this.searchCitiesRow.hide();
      this.updateShopsAddresses();
    } else {
      this.selfAddressesRow.hide();
      this.selfAddressesSelectRow.hide();
      this.searchCitiesRow.show();
    }

    if (info.value === deliveryType.courier) {
      this.searchCitiesRow.hide();
    }
  }

  updateShopsAddresses() {
    if (this.formAddresses[0].children.length) {
      $('.form-address').remove();
    }
    const url = this.placesRow.attr('data-cities');

    $.ajax({
      type: "GET",
      url,
      dataType: "json",
      success: (response) => {
        response.forEach((obj) => {
          const { address } = obj;
          this.formAddresses.append(
            `<a target="_blank" href="https://maps.google.com/?q=${address}" class="form-address">${address}</a>`
          );
        });
      },
      error(response) {
        console.log(response, 'error');
      }
    });
  }

  NPSelectRun(city) {
    if (!city) {
      this.NPCustomSelect.setData([]);
      return;
    }

    const citySettings = `{\r\n\"CityName\": \"${city}\",\r\n \"Language\": \"UA\"\r\n }`

    const settings = {
      "async": true,
      "crossDomain": true,
      "url": "https://api.novaposhta.ua/v2.0/json/",
      "method": "POST",
      "headers": {
        "content-type": "application/json",
      },
      "processData": false,
      "data": `{\r\n\"apiKey\": \"2dd9f517ba723b8003f7053972567a19\",\r\n \"modelName\": \"AddressGeneral\",\r\n \"calledMethod\": \"getWarehouses\",\r\n \"methodProperties\": ${citySettings} \r\n }`
    };

    $.ajax(settings)
     .done((response) => {
       const warehouses = [];
       response.data.forEach((obj) => {
         const address = obj.Description;
         warehouses.push({
           text: address,
           value: address
         })
       });

       this.NPCustomSelect.setData(warehouses);

       this.loader.hide();
     })
     .fail((xhr, status, error) => {
       console.log(xhr, status, error, 'error');
     });
  }

  initAutoComplete(addresses) {
    const { emptyMsg } = this.settings.strings.autocomplete;
    const $field = $('.js-typeahead').find('input');

    autocomplete({
      input: $field[0],
      render: (item) => {
        const div = document.createElement("div");
        div.textContent = item.label;
        return div;
      },
      fetch: (text, update) => {
        text = text.toLowerCase();
        const suggestions = addresses.filter(n => n.label.toLowerCase().startsWith(text));
        update(suggestions);
      },
      debounceWaitMs: 200,
      emptyMsg,
      onSelect: (item) => {
        $field.val(item.label);
        this.NPSelectRun(item.label);
      },
      preventSubmit: true,
    });

    $field.on('blur', () => {
      this.NPSelectRun($field.val());
    });
  }

  NPGetAddresses() {
    const settings = {
      "async": true,
      "crossDomain": true,
      "url": "https://api.novaposhta.ua/v2.0/json/",
      "method": "POST",
      "headers": {
        "content-type": "application/json",
      },
      "processData": false,
      "data": "{\r\n\"apiKey\": \"2dd9f517ba723b8003f7053972567a19\",\r\n \"modelName\": \"Address\",\r\n \"calledMethod\": \"getCities\"\r\n}"
    };


    $.ajax(settings)
      .done((response) => {
        const addresses = [];
        response.data.forEach((obj) => {
          const address = obj.Description;
          addresses.push({
            label: address,
            value: address
          })
        });

        this.initAutoComplete(addresses);
      })
      .fail((response) => {
        console.log(response, 'error');
      });
  }
}
/* eslint-enable */
